import discard from '@/store/modules/interactions/turns/discard';
import melds from '@/store/modules/interactions/turns/melds';
import draw from '@/store/modules/interactions/turns/draw';

export default {
    discard,
    draw,
    melds,
};
